import { render } from "./TheText.vue?vue&type=template&id=3a924fdd&scoped=true"
import script from "./TheText.vue?vue&type=script&lang=js"
export * from "./TheText.vue?vue&type=script&lang=js"

import "./TheText.vue?vue&type=style&index=0&id=3a924fdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a924fdd"]])

export default __exports__